var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnectMicrosoft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 50,
    viewBox: "0 0 42 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1392_270162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.96998 39.3529C8.55127 39.3529 7.39453 40.4575 7.39453 41.8283C7.39453 42.7601 7.93149 43.5585 8.73043 43.9845L18.6874 49.3208C19.4773 49.7661 20.3687 49.9998 21.2754 49.9994C21.8816 49.9994 22.4602 49.8932 22.9972 49.7067L26.3987 48.762V39.3398C26.4127 39.3529 9.983 39.3529 9.96946 39.3529H9.96998Z",
    fill: "url(#paint0_linear_1392_270162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96998 39.3529C8.55127 39.3529 7.39453 40.4575 7.39453 41.8283C7.39453 42.7601 7.93149 43.5585 8.73043 43.9845L18.6874 49.3208C19.4773 49.7661 20.3687 49.9998 21.2754 49.9994C21.8816 49.9994 22.4602 49.8932 22.9972 49.7067L26.3987 48.762V39.3398C26.4127 39.3529 9.983 39.3529 9.96946 39.3529H9.96998Z",
    fill: "url(#paint1_linear_1392_270162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7785 0.199516C22.3082 0.0652274 21.8213 -0.00192791 21.3322 4.21141e-05C20.5197 4.21141e-05 19.7073 0.159934 18.9771 0.53232C18.826 0.598985 2.78171 9.31543 2.78171 9.31543C2.5614 9.4222 2.35464 9.555 2.16194 9.68833C2.13485 9.70135 2.12079 9.7149 2.09319 9.72844C1.96923 9.82114 1.85882 9.91437 1.73539 10.0076C1.68018 10.0477 1.62497 10.1013 1.58383 10.1409C1.51508 10.2071 1.44581 10.2737 1.39113 10.3404C1.19842 10.5399 0.867704 10.9654 0.867704 10.9654C0.300305 11.772 -0.00285776 12.7348 2.03038e-05 13.721V36.8767C2.03038e-05 38.248 1.15676 39.3527 2.57547 39.3527C2.93327 39.3527 3.26399 39.286 3.5671 39.1527L8.15291 36.6642C8.97893 36.2653 9.64037 35.5861 9.98463 34.7476C10.0669 34.5747 10.1357 34.3622 10.1773 34.1486C10.1909 34.0955 10.2049 34.0289 10.2049 33.9757C10.2049 33.9497 10.2185 33.9096 10.2185 33.883C10.2325 33.7893 10.2461 33.683 10.2461 33.5903C10.2461 33.5101 10.2601 33.4435 10.2601 33.3638V21.0401V17.1939C10.2601 16.1158 10.7419 15.1444 11.4997 14.4658C11.4997 14.4658 11.1414 14.7851 11.4997 14.4658C11.8575 14.1466 12.3257 13.8669 12.8767 13.6809C13.4272 13.4809 26.4555 8.93002 26.4555 8.93002V1.25105L22.7785 0.199516Z",
    fill: "url(#paint2_linear_1392_270162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7785 0.199516C22.3082 0.0652274 21.8213 -0.00192791 21.3322 4.21141e-05C20.5197 4.21141e-05 19.7073 0.159934 18.9771 0.53232C18.826 0.598985 2.78171 9.31543 2.78171 9.31543C2.5614 9.4222 2.35464 9.555 2.16194 9.68833C2.13485 9.70135 2.12079 9.7149 2.09319 9.72844C1.96923 9.82114 1.85882 9.91437 1.73539 10.0076C1.68018 10.0477 1.62497 10.1013 1.58383 10.1409C1.51508 10.2071 1.44581 10.2737 1.39113 10.3404C1.19842 10.5399 0.867704 10.9654 0.867704 10.9654C0.300305 11.772 -0.00285776 12.7348 2.03038e-05 13.721V36.8767C2.03038e-05 38.248 1.15676 39.3527 2.57547 39.3527C2.93327 39.3527 3.26399 39.286 3.5671 39.1527L8.15291 36.6642C8.97893 36.2653 9.64037 35.5861 9.98463 34.7476C10.0669 34.5747 10.1357 34.3622 10.1773 34.1486C10.1909 34.0955 10.2049 34.0289 10.2049 33.9757C10.2049 33.9497 10.2185 33.9096 10.2185 33.883C10.2325 33.7893 10.2461 33.683 10.2461 33.5903C10.2461 33.5101 10.2601 33.4435 10.2601 33.3638V21.0401V17.1939C10.2601 16.1158 10.7419 15.1444 11.4997 14.4658C11.4997 14.4658 11.1414 14.7851 11.4997 14.4658C11.8575 14.1466 12.3257 13.8669 12.8767 13.6809C13.4272 13.4809 26.4555 8.93002 26.4555 8.93002V1.25105L22.7785 0.199516Z",
    fill: "url(#paint3_linear_1392_270162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4458 4.35042L22.9993 0.265625C25.0924 1.05102 26.4002 2.82077 26.4002 4.97696C26.4002 4.97696 26.3872 44.1426 26.4002 45.0874C26.4143 47.2165 25.0096 49.0399 22.9993 49.7185C23.4399 49.5987 37.4458 45.6994 37.4458 45.6994C39.5249 45.0608 41.0264 43.1973 41.0264 40.9755V9.07425C41.04 6.86598 39.5249 4.98894 37.4458 4.35042Z",
    fill: "url(#paint4_linear_1392_270162)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1392_270162",
    x1: 8.82366,
    y1: 43.4163,
    x2: 44.619,
    y2: 46.6573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F32B44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A4070A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1392_270162",
    x1: 33.0797,
    y1: 45.4673,
    x2: 17.1885,
    y2: 44.0283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1392_270162",
    x1: 23.3004,
    y1: -1.72491,
    x2: -3.07345,
    y2: 37.2527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#800600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C72127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#C13959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    stopColor: "#BC4B81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942,
    stopColor: "#B95799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B85BA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1392_270162",
    x1: 23.8655,
    y1: -2.5051,
    x2: 18.2802,
    y2: 5.74936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1392_270162",
    x1: 32.023,
    y1: -2.54368,
    x2: 32.023,
    y2: 46.2405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166,
    stopColor: "#EF8400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#E25C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    stopColor: "#DB4401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D83B01"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1392_270162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.04,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectMicrosoft);
export default __webpack_public_path__ + "static/media/connect-microsoft.06854ac8.svg";
export { ForwardRef as ReactComponent };